import { createRouter, createWebHistory } from "vue-router";

import { importChunk } from "../utils/chunk";

const router = createRouter({
	history: createWebHistory(),
	routes: [
		{
			name: "home",
			path: "/",
			redirect: "/debriefs",
		},
		{
			component: () => importChunk(() => import("../views/LoginView.vue")),
			name: "login",
			path: "/login",
		},
		{
			component: () => importChunk(() => import("../views/AccountSetupView.vue")),
			name: "setup-account",
			path: "/setup-account",
		},
		{
			component: () => importChunk(() => import("../views/OpenInAppView.vue")),
			name: "open-in-app-flight",
			path: "/open/flights/:flightId",
		},
		{
			component: () => importChunk(() => import("../views/Debriefs/DebriefListView.vue")),
			name: "debriefs",
			path: "/debriefs",
		},
		{
			component: () => importChunk(() => import("../views/Debriefs/DebriefDetailView.vue")),
			name: "debrief-detail",
			path: "/debriefs/:id",
		},
		{
			component: () => importChunk(() => import("../views/Config/ConfigView.vue")),
			path: "/config",
			children: [
				{ path: "", redirect: "/config/scorecard" },
				{
					component: () => importChunk(() => import("../views/Thresholds/ThresholdsView.vue")),
					name: "config-scorecard",
					path: "scorecard",
				},
				{
					component: () => importChunk(() => import("../views/Flags/FlagSettingsView.vue")),
					name: "config-flags",
					path: "flags",
				},
				{
					component: () => importChunk(() => import("../views/Performance/PerformanceTablesView.vue")),
					name: "config-performance",
					path: "performance",
				},
			],
		},
		// Pre-Config links (incl. the debrief email's) keep working.
		{ path: "/thresholds", redirect: "/config/scorecard" },
		{ path: "/flags", redirect: "/config/flags" },
		{
			component: () => importChunk(() => import("../views/Aircraft/AircraftView.vue")),
			name: "aircraft",
			path: "/aircraft",
		},
		{
			component: () => importChunk(() => import("../views/Fleets/FleetManagementView.vue")),
			name: "fleets",
			path: "/fleets",
		},
		{
			component: () => importChunk(() => import("../views/Fleets/PeopleView.vue")),
			name: "people",
			path: "/people",
		},
		{
			component: () => importChunk(() => import("../views/GarminSignups/GarminSignupsView.vue")),
			name: "garmin-signups",
			path: "/signups",
		},
		{
			component: () => importChunk(() => import("../views/Dashboard/AggregateDashboardView.vue")),
			name: "fleet-dashboard",
			path: "/fleets/:id/dashboard",
		},
		{
			path: "/fleets/:id/members",
			redirect: "/fleets",
		},
		{
			component: () => importChunk(() => import("../views/Thresholds/CohortThresholdsView.vue")),
			name: "cohort-thresholds",
			path: "/fleets/:id/thresholds",
		},
		{
			component: () => importChunk(() => import("../views/Interventions/InterventionsView.vue")),
			name: "fleet-interventions",
			path: "/fleets/:id/interventions",
		},
		{
			component: () => importChunk(() => import("../views/Parameters/AllParametersView.vue")),
			name: "fleet-parameters",
			path: "/fleets/:id/parameters",
		},
		{
			component: () => importChunk(() => import("../views/Flags/FlagSettingsView.vue")),
			name: "fleet-flags",
			path: "/fleets/:id/flags",
		},
	],
});

export default router;
